import { NavLink, useLocation } from 'react-router-dom';
import { PageContentAnimation } from '../../../../components/layout/page-content-animation';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { DashboardPaths } from '../../dashboard.router';
import { useMemo } from 'react';
import { PageBreadcrumbs, PageNavigation } from '@client/toolkit';
import { LockIcon } from '../../../../components/icons/lock-icon';
import { useUserPackages } from '../../../../hooks/useUserPackages';

export const DashboardHeader = () => {
  const location = useLocation();
  const { t: tGlobal } = useTranslation('global');
  const { t: tDashboard } = useTranslation('dashboard');
  const { getAvailablePackages } = useUserPackages();

  const tabs = useMemo(() => {
    const { management, economy, eos, portfolio } = getAvailablePackages();
    return [
      {
        key: 'portfolio',
        label: tGlobal('navigation.dashboard.portfolio'),
        to: `${DashboardPaths.Portfolio}${location.search}`,
        hasAccess: portfolio,
      },
      {
        key: 'agreements',
        label: tGlobal('navigation.dashboard.agreements'),
        to: `${DashboardPaths.Management}${location.search}`,
        hasAccess: management,
      },
      {
        key: 'economical',
        label: tGlobal('navigation.dashboard.economical'),
        to: `${DashboardPaths.Economical}${location.search}`,
        hasAccess: economy,
      },
      {
        key: 'eos',
        label: tGlobal('navigation.dashboard.eos'),
        to: `${DashboardPaths.Energy}${location.search}`,
        hasAccess: eos,
      },
    ];
  }, [tGlobal, getAvailablePackages, location.search]);

  return (
    <>
      <PageContentAnimation className="flex flex-col gap-5">
        <PageNavigation>
          <PageBreadcrumbs>
            <PageBreadcrumbs.Link>{tDashboard('navigation.dashboard')}</PageBreadcrumbs.Link>
          </PageBreadcrumbs>
        </PageNavigation>
      </PageContentAnimation>
      <PageContentAnimation className="flex gap-5">
        <div className="flex w-full md:w-auto  flex-col md:flex-row p-2 gap-1 rounded-md bg-surface-elevated/30">
          {tabs.map((tab) => (
            <NavLink
              key={tab.key}
              to={tab.to}
              className={({ isActive }) =>
                classNames(
                  'min-w-[165px] text-[0.875rem] font-bold px-5 h-[33px] rounded-md flex items-center justify-center',
                  isActive ? 'bg-surface-elevated' : '',
                  !tab.hasAccess ? 'bg-surface-elevated/30 text-secondary' : 'text-primary',
                )
              }
              end
            >
              {tab.label}
              {!tab.hasAccess ? <LockIcon className="ml-2" /> : null}
            </NavLink>
          ))}
        </div>
      </PageContentAnimation>
    </>
  );
};
